"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var logger = __importStar(require("../logger/logger"));
var location_tools_1 = require("../helpers/location-tools");
var randomizers_1 = require("../helpers/randomizers");
var crux_state_1 = __importDefault(require("./state/crux-state"));
var domains_1 = require("./domains");
var base64_1 = require("../helpers/base64");
var is_of_type_1 = __importDefault(require("../helpers/is-of-type"));
var isTrustedScriptUrl_1 = __importDefault(require("../helpers/isTrustedScriptUrl"));
var base64_helpers_1 = require("../helpers/base64-helpers");
var displayName = 'Crux.mess';
// modes
var APPLICATION = 'application';
var TARGET = 'target';
var BEACON = 'beacon';
var STATIC = 'static';
// depths
var SEARCH = 'search';
var FOLDER = 'folder';
var FILE = 'file';
// helpers
var ES = '';
var SL = '/';
var STATIC_HOST = 'v.wpimg.pl';
var APPLICATION_LENGTH = 900 / 1.35;
var ADV_REGEXP = /(?:(?:https?:)?(?:\/\/)?)adv\.wp\.pl/i;
var OAS_CDN = 'https://oas.wpcdn.pl';
var allDomains = __spreadArray(__spreadArray(__spreadArray([], domains_1.aabDomains, true), domains_1.uniformDomains, true), domains_1.pixelDomains, true);
var staticIdentifiers = ['ii', 'ij', 'ia', 'ib', 'ic', 'id', 'ms', 'iw', 'sd', 'ad'];
var beaconIdentifiers = ['do', 'rk', 'aabma'];
var applicationIdentifiers = ['aabko', 'aabdc', 'aabkord', 'maw', 'daw'];
var hashCode = function (str) { return String(Array.from(str)
    // eslint-disable-next-line no-bitwise
    .reduce(function (hash, char) { return 0 | (31 * hash + char.charCodeAt(0)); }, 0)); };
/**
 * @description
 * Rozszerza zakodowany url do odpowiedniej długości
 * @param objectToSend
 * @param input
 * @param limit
 * @param rand
 * @param char
 */
var extend = function (inObjectToSend, inInput, inLimit) {
    var objectToSend = inObjectToSend;
    var input = inInput.trim();
    var limit = inLimit + 2;
    if (input && input.length < limit) {
        objectToSend._ = '_'.repeat(limit - input.length);
    }
};
var reJSCSS = /(\.js(on)?|\.css)$/i;
var reImage = /(\.jp(e)?g|\.(g|av)if|\.webp|\.(a)?png|\.svg|\.ico)$/i;
var reHTML = /^(?!.*_mess\.html$).*\.html$/i;
var reSLASH = /\//g;
var rePLUS = /\+/g;
var reFOLDER = /^(.+)\/([^/]*)$/;
/**
 * @description
 * @function
 *
 * @param  {} [args] url, forceLoad, immutable, mode, depth,
 * forceDomain, length, keybase, noDomain
 * @param  {string} [url]
 * @param  {boolean} [forceLoad]
 * @param  {boolean} [immutable] Zapewnia stałość adresów
 * @param  {string} [mode] target, application, static, beacon
 * @param  {string} [depth] folder, search, file
 * @param  {string} [forceDomain]
 * @param  {number} [length] Minimalna długość adresu
 * @param  {string} [keybase] Ziarno uzywane do generowania adresu
 * @param  {boolean} [noDomain]
 */
var mess = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var objectToSend = {};
    var data = {};
    var momentaryState = null;
    var noDomain = false;
    var noEncode = ES;
    var encoded = ES;
    var output = ES;
    var url = ES;
    var forceLoad;
    var immutable;
    var mode;
    var depth;
    var forceDomain;
    var length;
    var keybase;
    if (is_of_type_1.default.o(args[0]) && !(0, isTrustedScriptUrl_1.default)(args[0])) {
        (_a = args[0], url = _a.url, forceLoad = _a.forceLoad, immutable = _a.immutable, mode = _a.mode, depth = _a.depth, forceDomain = _a.forceDomain, length = _a.length, keybase = _a.keybase, noDomain = _a.noDomain, momentaryState = _a.momentaryState);
    }
    else {
        url = args[0], forceLoad = args[1], immutable = args[2], mode = args[3], depth = args[4], forceDomain = args[5], length = args[6], keybase = args[7], noDomain = args[8], momentaryState = args[9];
    }
    if ((0, isTrustedScriptUrl_1.default)(url)) {
        url = url.toString();
    }
    data.input = url;
    logger.debug(data);
    var state = momentaryState || crux_state_1.default;
    // tylko gdy jestesmy w przegladarce
    if (state.collector) {
        state.collector(data);
    }
    // Uniform wyłączony
    if (!state.enabled) {
        data.error = 'disabled';
        // koniec
        return url;
    }
    //  brak url'a
    if (!url) {
        logger.issue('Given URL is empty.');
        data.error = 'empty URL';
        // koniec
        return url;
    }
    // dataURI nie kodujemy
    if (url.startsWith('data:')) {
        // zwracamy bez zmian
        return url;
    }
    if (url.includes('adv.wp.pl')) {
        url = url.replace(ADV_REGEXP, OAS_CDN);
        logger.issue('Use "oas.wpcdn.pl" instead of "adv.wp.pl".');
    }
    // jezeli adres juz zakodowany jako statyczny
    if (url.includes("/".concat(STATIC_HOST, "/"))) {
        // adres zawiera domenę ImageResizer'a
        if (url.includes('/i.wpimg.pl/')) {
            logger.issue('URL can\'t be encoded before ImageResizer.');
            data.error = 'encoded before IR';
        }
        else {
            logger.issue('URL can\'t be encoded twice.');
            data.error = 'encoded twice';
        }
        // zwracamy bez zmian i kończymy
        return url;
    }
    // ma byc z cache
    if (forceLoad) {
        // wymuszam pobranie z serwera raz na 15 min.
    }
    // rozbieramy adres
    var urlLocation = (0, location_tools_1.parsePath)(url);
    if (urlLocation.error) {
        logger.issue("Given URL \"".concat(url, "\" is incorrect."));
        data.error = 'incorrect URL';
        return urlLocation.data;
    }
    var urlHostname = urlLocation.hostname;
    var urlPathname = urlLocation.pathname;
    data.inputLength = url.length;
    data.hostname = urlHostname;
    data.pathname = urlPathname;
    // sprawdzam czy plik jest z CEPH i nadaję identyfikator
    var identifier = (0, domains_1.getCephIdentifier)(urlHostname);
    // jezeli nie znalezione id z CEPH'a
    if (!identifier) {
        // biorę identyfikator domeny z mapy
        identifier = domains_1.domainMap[urlHostname];
    }
    // jezeli id nadal nieznalezione
    // i plik jest w domenie serwisu
    // i domena jest obsługiwana przez NGINX
    if (!identifier
        && urlHostname === state.locationHost
        && allDomains.includes(urlHostname)) {
        // id serwisowy na potrzeby doboru trybu
        identifier = 'hh';
    }
    else {
        // id do zakodowania w adresie
        // nie mozemy dodawać 'hh'
        objectToSend.t = identifier;
    }
    // jezeli nadal nie ma id
    if (!identifier) {
        data.error = 'no identifier';
        // konczymy bo to błąd
        return url;
    }
    // czy plik to JS/JSON/CSS
    var isJsOrCss = reJSCSS.test(urlPathname);
    var isImage = reImage.test(urlPathname);
    var isPixel = domains_1.pixelDomains.includes(urlHostname);
    if (is_of_type_1.default.u(mode)) {
        // dla zasobów z CEPH'a
        if (identifier.startsWith('cph')) {
            if (isJsOrCss) {
                mode = APPLICATION;
                // jezeli zasób z STD (ATFD)
                if (identifier === 'cph_std') {
                    var kb = Math.floor((Date.now() / (7 * 24 * 60 * 60 * 1000))).toString().repeat(2);
                    // ustawiam keybase tygodniowy, tryb aplikacyjny
                    // i kodowanie pełnego adresu
                    keybase = hashCode(kb);
                }
            }
            else {
                mode = STATIC;
            }
        }
        // dla zasobów z serwisu
        if (identifier === 'hh') {
            if (isJsOrCss || isPixel) {
                mode = APPLICATION;
            }
            else if (isImage) {
                mode = STATIC;
            }
            else {
                // konczymy bo to błąd
                return url;
            }
            // dla JS/JSON i CSS
        }
        else if (applicationIdentifiers.includes(identifier)) {
            mode = APPLICATION;
            // dla zliczen
        }
        else if (beaconIdentifiers.includes(identifier)) {
            mode = BEACON;
            keybase = (0, randomizers_1.randomize)(10, 36);
            // dla statyków
        }
        else if (staticIdentifiers.includes(identifier)) {
            mode = STATIC;
        }
    }
    // dla statyków
    if (mode === STATIC) {
        // jezeli nie ustalona głębokości kodowania
        if (is_of_type_1.default.u(depth)) {
            // dla ramek HTML bez suffix'u '_mess'
            if (reHTML.test(urlPathname)) {
                // kodujemy do folderu, bo pliki w ramce mają ścieżki relatywne !!!
                depth = FOLDER;
            }
        }
    }
    // jezeli nie ustawiono inaczej
    if (is_of_type_1.default.u(immutable)) {
        // wszystko ma stałe adresy
        immutable = true;
    }
    // jezeli nie ustawiono inaczej
    if (is_of_type_1.default.u(depth)) {
        // kodujemy pełny adres
        depth = SEARCH;
    }
    data.length = length;
    data.mode = mode;
    data.depth = depth;
    data.identifier = identifier;
    data.immutable = immutable;
    // na początku kodujemy do domeny zasobów statycznych
    var outputHost = STATIC_HOST;
    // jezeli wymuszono domenę
    if (forceDomain) {
        // kodujemy do wskazanej
        outputHost = forceDomain;
    }
    else if (mode === APPLICATION || mode === BEACON || identifier === 'hh') {
        // kodujemy do domeny serwisu
        outputHost = state.applicationHost;
    }
    else if (mode === TARGET) {
        // kodujemy do domeny dla linków ze stron głównych
        outputHost = state.targetHost;
    }
    // brak domeny
    if (!outputHost) {
        data.error = 'no hostname';
        // konczymy bo to błąd
        return url;
    }
    if (mode === APPLICATION || mode === BEACON || length > 0) {
        // wydłuzamy adres
        extend(objectToSend, url, length || APPLICATION_LENGTH);
    }
    // zawsze HTTPS
    outputHost = "https://".concat(outputHost);
    var toEncode = ES;
    // jezeli sciezka zaczyna sie od slasha
    if (urlPathname.startsWith(SL)) {
        // kodowanie bez 1 slasha
        toEncode = decodeURIComponent(urlPathname.substr(1));
        toEncode = unescape(encodeURIComponent(toEncode));
    }
    // jezeli ma byc zakodowany cały adres z plikiem
    if (depth === FILE || depth === SEARCH) {
        // nie kodujemy search
        noEncode = urlLocation[SEARCH];
        // jezeli wszystkie parametry
        if (depth === SEARCH) {
            noEncode = ES;
            // kodujemy takze search
            toEncode += urlLocation[SEARCH];
        }
    }
    else {
        // wyciagam sciezke folderow
        var parts = toEncode.match(reFOLDER);
        // jezeli nie ma czesci folderowej
        if (!parts) {
            data.error = 'encoding not needed';
            // koncze, nie koduje
            return url;
        }
        // kodujemy sciezka folderow
        toEncode = parts[1] + SL;
        // nie kodujemy reszty
        noEncode = parts[2] + urlLocation[SEARCH];
    }
    objectToSend.u = SL + toEncode;
    data.json = objectToSend;
    toEncode = "/aabv3/".concat(JSON.stringify(objectToSend));
    // Generowanie klucza do xorowania
    // dla konkretnego url'a zawsze wygeneruje ten sam klucz,
    // ale tez nie kazdy klucz bedzie podobny (czego mozna by uzyc w filtrach)
    // ten klucz moze byc dowolnymi znakami ascii (i tak jest przekazywany nginx'owi),
    // wiec mozna to zmienic na cokolwiek, byle nie stale
    if (!keybase || keybase.length < 8) {
        if (immutable) {
            keybase = urlPathname;
        }
        else {
            keybase = (0, randomizers_1.randomize)(10, 36);
        }
    }
    try {
        data.inKeybase = keybase;
        keybase = (0, base64_1.btoa)(keybase).substr(-12, 8);
        data.keybase = keybase;
        data.toEncode = toEncode;
        data.noEncode = noEncode;
        if (noDomain) {
            output = SL + keybase;
        }
        else {
            output = outputHost + SL + keybase;
        }
        var sxored = (0, randomizers_1.sxor)(toEncode, keybase);
        encoded = (0, base64_helpers_1.removeEqualSigns)((0, base64_1.btoa)(sxored));
    }
    catch (err) {
        data.error = (err && err.message) || 'Failed to encode with Base64';
        logger.issue("".concat(displayName, ": ").concat(data.error, " (").concat(url, ")"));
        return url;
    }
    encoded = encoded.replace(reSLASH, '_');
    encoded = encoded.replace(rePLUS, '-');
    var path = encoded + (noEncode ? (SL + noEncode) : ES);
    output += path;
    data.output = output;
    data.outputLength = output.length;
    // console.log(data);
    // CRITICAL ten limit 3000 zn. jest ustawiany na NGINX w module dekodującym
    // CRITICAL przekroczenie wysyła zakodowany adres w kosmos !!!!!!!!
    // CRITICAL nie zmienić bez konsultacji z adminami
    if (data.outputLength > 3000) {
        logger.issue(false, {
            message: 'AAB',
            fileName: url.substring(0, 250),
            path: 'EncodedURLTooLong',
            campaign: data.outputLength,
        });
        data.error = 'encoded URL too long';
        return url;
    }
    // zwracamy nowy url
    return output;
};
exports.default = mess;
